import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Top from '../Top/Top';
import ProductItem from './ProductItem';
import TemplateParser from '../Templates/TemplateParser';
import Filter from '../../hocs/Filter/Filter';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { origin } from '../../config';
import { prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Category.scss';

const Category = ({ data, currentPath, setup, productCache, filter, pageType }) => {
	const cache = productCache?.[setup.market]?.[setup.pricelist];
	if (!data || !cache || pageType !== 'category') return null;
	const parts = data?.parts || [];
	const contentSections = [];
	const collectionSections = {};
	const bottomSections = [];
	const isFiltered = filter.filteredBy.filter((f) => Object.keys(f)[0] !== 'categories').length > 0 || filter.sort !== '';
	let topSections = 0;

	data.content.linkCanonical = `${origin}${prefix(setup, currentPath)}`;

	if (!isFiltered) {
		parts.forEach((section) => {
			const insertPosition = parseInt(section?.partsMeta?.priority, 10) || 0;
			let collectionPosition = section?.partsMeta?.product?.[0] || false;

			if (collectionPosition) {
				collectionPosition = urlify(collectionPosition);
				if (!collectionSections[collectionPosition]) collectionSections[collectionPosition] = [];
				if (collectionSections[collectionPosition][insertPosition]) {
					collectionSections[collectionPosition][collectionSections[collectionPosition].length] = section;
				} else {
					collectionSections[collectionPosition][insertPosition] = section;
				}
				return;
			}


			if (insertPosition < 0) {
				if (bottomSections[Math.abs(insertPosition)]) {
					bottomSections[bottomSections.length] = section;
				} else {
					bottomSections[Math.abs(insertPosition)] = section;
				}
			} else if (insertPosition === 0) {
				collectionSections.general = [section];
			} else if (contentSections[insertPosition]) {
				contentSections[contentSections.length] = section;
			} else {
				contentSections[insertPosition] = section;
			}
		});
	}

	const isLocalized = cache.localized[setup.language];
	const categoryTitles = isLocalized ? Object.keys(cache.filterArrays.categories).reduce((acc, cat) => {
		const categoryKey = isLocalized.categories[cat] ? isLocalized.categories[cat].key : cat;
		const categoryDescription = isLocalized.categories[cat] ? isLocalized.categories[cat].description : cache.filterDescriptions.categories[cat];
		return ({ ...acc, [categoryKey]: categoryDescription });
	}, {}) : cache.filterDescriptions.categories;
	const categoryTitle = categoryTitles[currentPath];

	const topSectionsContent = contentSections.map((section, i) => {
		if (section === undefined || i > topSections || !section?.partsMeta?.display || section.partsMeta.display !== 'block') return null;
		topSections += 1;
		return <TemplateParser key={i} sections={section.sections} setup={setup} />;
	});

	console.log('DEBUG: topSectionsContent', collectionSections);

	return (
		<main role="main" className={s.category}>
			<Top setup={setup} pageContent={data.content} paths={data.paths} />
			{
				topSectionsContent.length > 0 && <div className={s.category_topCMS}>{ topSectionsContent }</div>
			}
			<ErrorBoundary message="Filter:" debugData={cache}>
				<Filter ListComponent={ProductItem} filter={filter} filtering={cache} data={data} setup={setup} currentPath={currentPath} currentView={categoryTitle} collectionSections={collectionSections} contentSections={contentSections.slice(topSections)} />
			</ErrorBoundary>
			<div className={s.category_topCMS}>
				{
					bottomSections.map((section, i) => {
						if (section === undefined) return null;
						return <TemplateParser key={i} sections={section.sections} setup={setup} />;
					})
				}
			</div>
		</main>
	);
};

const mapState = ({ environment, productCache, filter }, { data, currentPath }) => ({
	data,
	currentPath,
	setup: environment.setup,
	productCache,
	filter,
});

export default hot(module)(connect(mapState)(Category));
